

















































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import  MswAppTitle  from '@/shared/msw-app-title/msw-app-title.vue';
import UUIFComponents from '@/shared/uuifComponent';
import {
  SwTable, TableColumnConfig, TableEntry,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { v4 as uuidv4 } from 'uuid';
import { CreateElement, VNode } from 'vue';
import { SwForm, SwFormRow } from '@sonicwall/unified-ui-framework/src/shared/sw-form';
import { SwRadio } from '@sonicwall/unified-ui-framework/src/shared/sw-radio';
import { DropMenuItem, SwDropMenu } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import ExportcsvService from '@/shared/msw-exportcsv.service';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import {
  ContentToolbarExpandFilterBlock,
  SwContentToolbar,
  SwContentToolbarExpand,
} from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';

const cssPrefix = 'issueList';
@Component({
  components: {
    ...UUIFComponents,
    MswAppTitle,
    SwTable,
    SwContentToolbar,
    SwDropMenu,
    SwCheckbox,
    SwContentToolbarExpand,
    SwForm,
    SwFormRow,
    SwRadio,
  },
})

export default class MswIssueList extends SwExtendedVue {
  cssPrefix = cssPrefix;
  issueHeader: string = '';
  issueDescription: string = '';
  tableData: TableEntry[] = []; // For table data
  filterdData: TableEntry[] = [];
  exportMenuOpened: boolean = false;
  exportMenuItems: DropMenuItem[] = [
    { id: 'csv', content: 'Export CSV' },
    { id: 'xls', content: 'Export XLS' },
  ];
  expandVisible: boolean = false;
  filterBlockGrid: ContentToolbarExpandFilterBlock[][] = [];

  issueLIstTableColumnConf: TableColumnConfig[] = [
    {
      key: 'index',
      type: 'index',
    },
  ];

  viewRemedyTypeDesc: any[] = [
    { key: 'All', label: 'All' },
    { key: 'Yes', label: 'Yes' },
    { key: 'No', label: 'No' },
  ];

  productTypeSelectValue: string = 'All';

  created() {
    this.loadFilterData();
    this.fetchIssueListHeaders();
  }

  get getTableHeight() {
    let remainsTableHeight = 390;
    if (this.expandVisible) {
      remainsTableHeight = 500;
    }
    return remainsTableHeight;
  }

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  loadFilterData() {
    const tableHeader = document.querySelector('.msw-table-toolbar') as HTMLElement;
    let totalWidth = 0;
    if (tableHeader) {
      totalWidth = tableHeader.getBoundingClientRect().width;
    }
    this.filterBlockGrid = [
      [
        {
          title: 'REMEDIATED',
          content: this.viewRemediatedRender,
          width: totalWidth / 4 || 200,
        },
      ],
    ];
  }

  private viewRemediatedRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          this.viewRemedyTypeDesc.map<VNode>((val: any) => {
            return (
              <SwFormRow no-label>
                <div class={['sw-flexbox__flex']}>
                  <SwRadio
                    {...{
                      props: {
                        name : val.label,
                        value : val.key,
                        pickedValue : this.productTypeSelectValue,
                      },
                      nativeOn: {
                        change: (event : any) => {
                          const clickedValue = event.target.value;
                          this.applyFilters(clickedValue);
                        },
                      },
                    }}> { val.label } </SwRadio>
                </div>
                <div class={['sw-flexbox__flex-none', 'csc-filter-item-subtotal']}>{ val.count }</div>
              </SwFormRow>
            ) as VNode;
          })
        }
      </SwForm>
    ) as VNode;
  }
  fetchIssueListHeaders() {
    // reset table config and data
    this.issueLIstTableColumnConf = [{
      key: 'index',
      type: 'index',
    }];
    this.tableData = [];
    this.filterdData = [];
    // fetch table data
    this.$store.dispatch('MswIssueListModule/fetchIssueListHeaders')
      .then((response: any) => {
        if (response.msgCode === 'MSWAPP:GETISSUEDETAILSSUCCESS') {
          this.issueHeader = response?.content?.issuueHeader || '';
          this.issueDescription = response?.content?.IssueDescription || '';
          if (response.content.ColDescs) {
            response.content.ColDescs.split(',').map((ele: string, index: number) => {
              if (ele.trim() === 'Remediated') {
                this.issueLIstTableColumnConf.push({
                  key: ele,
                  dataKey: 'isRemedy',
                  title: ele,
                  // tslint:disable-next-line:no-unused
                  render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
                    const temRemedyValue = data.entry.isRemedy.toLowerCase();
                    const remedyValue:boolean = (temRemedyValue === 'yes');
                    return (
                      <div>
                        <span class={['sw-flexbox', 'sw-flexbox--center-items']}>
                          {<SwCheckbox name="resellercheckbox" props-checked={remedyValue}
                          nativeOn-click={ () => this.updateRemedyValue(data.entry) } > </SwCheckbox>}
                        </span>
                      </div>
                    ) as VNode;
                  },
                });
              } else {
                this.issueLIstTableColumnConf.push({
                  key: ele,
                  dataKey: `col${index + 1}Val`,
                  title: ele,
                });
              }
            });
          }
          this.tableData = response?.content?.issueListsNew.map((ele: any, index: number) => {
            return {
              ...ele,
              _key : `${uuidv4()}`,
              index : index + 1,
            };
          });
          this.filterdData = this.tableData;
        }
      })
      .catch((errorResponse: any) => {
        console.table(errorResponse);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  updateRemedyValue(item: TableEntry) {
    const payload = {
      serialNumber: item.col1Val,
      isRemedy: (item.isRemedy.toLowerCase() === 'yes') ? 'NO' : 'YES',
    };
    this.$store.dispatch('MswIssueListModule/saveRemediateDetails', payload)
      .then((response: any) => {
        if (response.operationStatus === 'OK') {
          this.fetchIssueListHeaders();
        }
      })
      .catch((errorResponse: any) => {
        console.table(errorResponse);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  applyFilters(filterValue: string) {
    this.productTypeSelectValue = filterValue;
    if ((filterValue === 'Yes') || (filterValue === 'No')) {
      this.filterdData = this.tableData.filter((ele: any) => ele.isRemedy.toLowerCase() === filterValue.toLowerCase());
    } else {
      this.filterdData = this.tableData;
    }
  }

  onChangeExport(itemId: string) {
    if (itemId === 'csv') {
      this.exportCsv();
    } else {
      this.exportXls();
    }
  }

  exportXls() {
    const XLSX = require('xlsx');
    const dataToExport = this.mapDataForExport(this.tableData, true);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_json(ws, dataToExport, {
      origin: 'A1',
      skipHeader: false,
      cellDates: true,
      dateNF: 'MMM DD yyyy',
    });
    XLSX.utils.book_append_sheet(wb, ws, 'Issues');
    XLSX.writeFile(wb, 'IssueList.xlsx');
  }

  mapDataForExport(csvData: any[], isXls: any) {
    const filterJson: any = [];
    const itemHeader: any = [];
    this.issueLIstTableColumnConf.map((ele: any) => {
      if (ele.dataKey !== undefined) {
        itemHeader.push(ele.title);
      }
    });
    !isXls && filterJson.unshift(itemHeader);
    csvData.map((dataItem:any) => {
      const obj = {};
      this.issueLIstTableColumnConf.forEach((item) => {
        // // @ts-ignore
        if (item.dataKey && item.dataKey !== 'actions') {
          // @ts-ignore
          obj[item.title] = dataItem[item.dataKey]?.toString();
        }
      });
      filterJson.push(obj);
    });
    return filterJson;
  }

  startExport(productsList:any, name:string) {
    const XLSX = require('xlsx');
    const link = document.createElement('a');
    if (name.includes('.xls')) {
      const excel = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(productsList);
      ws['!autofilter'] = { ref: ws['!ref'] };
      XLSX.utils.book_append_sheet(excel, ws, 'Report');
      const finalExel = XLSX.writeFile(excel, name.concat('x'));
      const blobOb = new Blob(finalExel, { type: 'text/xls;charset=utf-8;' });
      link.href = URL.createObjectURL(blobOb);
      link.setAttribute('style', 'font-weight: bold');
      link.download = name.concat('x');
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  exportCsv() {
    ExportcsvService.export(this.mapToExport(this.tableData), 'IssueList.csv');
  }

  mapToExport(csvData: any[]) {
    let filterJson: any[] = [];
    const itemHeader: string[] = [];
    this.issueLIstTableColumnConf.map((entry: TableColumnConfig) => {
      if (entry.key !== 'index' && typeof entry.title === 'string') {
        itemHeader.push(entry.title.toUpperCase());
      }
    });
    const tempJson: any = [{}, itemHeader];
    csvData.map((dataItem:any) => {
      const obj = {};
      this.issueLIstTableColumnConf.forEach((item) => {
        if (item.dataKey) {
          // @ts-ignore
          obj[item.title] = dataItem[item.dataKey];
        }
      });
      tempJson.push(obj);
    });
    filterJson = filterJson.concat(tempJson);
    return filterJson;
  }
}
